import React, {Component} from 'react'
import {Button, Card, Col, List, Row, notification} from 'antd';
import Request from '../../request'
import ReceiptsView from '../../components/DocumentViews/receiptsView'
import FinanceClaim from '../../containers/finance/all/index';
// import FinanceClaim from '../finance/all/index';
import AllInvoiceFollowUp from '../../components/_utils/allInvoiceFollowUp';

import {
    FaMoneyCheckAlt,
    FaRegBuilding,
    FaUserCog,
    FaFileInvoiceDollar,
    FaRegMoneyBillAlt,
    FaFileInvoice,
    FaPlaneDeparture,
    FaHistory,
    FaUserSlash,
    FaUserTimes,
    FaUserCheck,
    FaUserClock
} from "react-icons/fa";

import ConsultancyIcon from '../../assets/icons/registration/ConsultancyIcon.png'
import RegistrationIcon from '../../assets/icons/registration/RegistrationIcon.png'
import OutstandingIcon from '../../assets/icons/registration/OutstandingIcon.png'
import {getUrlPushWrapper} from "../../routes";
import {connect} from "react-redux";
import {
    FaRupeeSign
} from "react-icons/fa";
import { RightsWrapper } from '../_utils/utils';

class FinanceTaxesCount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            coldCount: 0,
            outstandingAgreement: {
                total: 0,
                arr: []
            },
            drawer: false,
            drawerParam: {},
            todaySubmittedReceipts: [],
            showTPSCSubmittedButton: false,
            showTECSubmittedButton: false,
            showAccountPaymentDrawar: false,
            submitReceiptCount: {
                submittedCount: 0,
                approvedCount: 0
            },
            visaApprovedTodayCount: {
                total: 0
            },
            invoiceToBeGeneratedTodayCount: {
                total: 0
            },
            invoiceGeneratedTodayCount: {
                total: 0
            },
            totalTaxCount: {
                total: 0
            },
            totalCompaniesDetailsCount: {
                total: 0
            },
            totalInvoicesToDetailsCount: {
                total: 0
            },
            universityCommissionEntered: {
                total: 0
            },
            courseCommissionEntered: {
                total: 0
            },
            InvoiceWaitingForCommissionEntered: {
                total: 0
            },
            overdueInvoices: {
                total: 0
            },
            totalWithdrawStudents: {
                total: 0
            },
            totalWithdrawRequestSent: {
                total: 0
            },
            studentWithdrawRequestApproved: {
                total: 0
            },
            studentWithdrawRequestRejected: {
                total: 0
            }
        }
    }

    loadApi = async() => {
        Request.getCliamDeskData().then(({
            visaApprovedTodayCount, 
            invoiceToBeGeneratedTodayCount, 
            invoiceGeneratedTodayCount,
            overdueInvoices,
            totalWithdrawStudents,
            totalWithdrawRequestSent,
            studentWithdrawRequestApproved,
            studentWithdrawRequestRejected,
            totalTaxCount,
            totalCompaniesDetailsCount,
            totalInvoicesToDetailsCount,
            universityCommissionEntered,
            courseCommissionEntered
        }) => {
            this.setState({
                visaApprovedTodayCount, 
                invoiceToBeGeneratedTodayCount, 
                invoiceGeneratedTodayCount,
                overdueInvoices,
                totalWithdrawStudents,
                totalWithdrawRequestSent,
                studentWithdrawRequestApproved,
                studentWithdrawRequestRejected,
                totalTaxCount,
                totalCompaniesDetailsCount,
                totalInvoicesToDetailsCount,
                universityCommissionEntered,
                courseCommissionEntered
            });
        }); 
    }

    async componentDidMount() {
        await this.loadApi();
    }

    approveTodayFees = async() => {
        let response = await Request.approveTodayFees({});
        if(response.success === true) {
            notification.success({
                message: response.msg,
            });
            this.loadApi();
        } else {
            notification.error({message: "Try again"});
        }
    }

    viewAccountPaymentReceipt = () => {
        this.setState({
          showAccountPaymentDrawar: true
        })
    }
    
    closeDocument = () => {
        this.setState({showAccountPaymentDrawar: false});
    }

    exportExcelTodaysReceipts = async() => {
        let response = await Request.exportTodaysPayments();
        if (!response.error) {
            window.location.href = response.url;
        }
    }

    render() {
        let {dispatch} = this.props

        const {
            visaApprovedTodayCount, 
            invoiceToBeGeneratedTodayCount, 
            invoiceGeneratedTodayCount,
            totalTaxCount,
            totalCompaniesDetailsCount,
            totalInvoicesToDetailsCount,
            universityCommissionEntered,
            courseCommissionEntered,
            overdueInvoices,
            totalWithdrawStudents,
            totalWithdrawRequestSent,
            studentWithdrawRequestApproved,
            studentWithdrawRequestRejected,
            showAccountPaymentDrawar
        } = this.state;

        const {
            todaySubmittedReceipts,
        } = this.state;

        let todaysPaymentHtml = [];
        let totalPaidToday = 0;
        todaySubmittedReceipts.map((todayRegistrationsReceipt, index) => {
            totalPaidToday += parseFloat(todayRegistrationsReceipt.totalAmount);
            todaysPaymentHtml.push(
                <tr key={index}>
                    <td>{todayRegistrationsReceipt.amountType}</td>
                    <td>{todayRegistrationsReceipt.studentId}</td>
                    <td>{todayRegistrationsReceipt.studentName}</td>
                    <td>{todayRegistrationsReceipt.dob}</td>
                    <td>{todayRegistrationsReceipt.receiptNumber}</td>
                    <td><FaRupeeSign />{todayRegistrationsReceipt.totalAmount}</td>
                    <td>{todayRegistrationsReceipt.paymentType}</td>
                    <td>{todayRegistrationsReceipt.remarks}</td>
                    <td>{todayRegistrationsReceipt.submittedDate && todayRegistrationsReceipt.approvedDate?'Approved':(todayRegistrationsReceipt.submittedDate?'Submitted':'Pending')}</td>
                </tr>
            )
        })
        let showApprovedButton = false;
        if(this.state.todaySubmittedReceipts && this.state.todaySubmittedReceipts.length === this.state.submitReceiptCount.submittedCount) {
            showApprovedButton = true;
        }
        if(this.state.todaySubmittedReceipts && this.state.todaySubmittedReceipts.length === this.state.submitReceiptCount.approvedCount) {
            showApprovedButton = false;
        }

        return (
            <div>
                <div className="site-card-wrapper">
                    {/* <RightsWrapper myRight={"financeTaxesCount.view"}>
                    <Row>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-1 elevation-1"><FaMoneyCheckAlt /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Tax Count</span>
                                    <span className="info-box-number">
                                        <a href='/finance-tax' target='_blank'>{totalTaxCount.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Companies Details Counts</span>
                                    <span className="info-box-number">
                                        <a href='/company-details' target='_blank'>{totalCompaniesDetailsCount.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaUserCog /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Invoice To Details Count</span>
                                    <span className="info-box-number">
                                        <a href='/invoice-to-details' target='_blank'>{totalInvoicesToDetailsCount.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-4 elevation-1"><FaPlaneDeparture /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Visa Approved Today</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Visa Approved Today`,
                                                    arr: visaApprovedTodayCount.arr,
                                                    count: visaApprovedTodayCount.total
                                                }
                                            })
                                        }}>{visaApprovedTodayCount.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-5 elevation-1"><FaFileInvoice /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Invoice To Be Generated Today</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Invoice To Be Generated Today`,
                                                    arr: invoiceToBeGeneratedTodayCount.arr,
                                                    count: invoiceToBeGeneratedTodayCount.total
                                                }
                                            })
                                        }}>{invoiceToBeGeneratedTodayCount.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-6 elevation-1"><FaFileInvoiceDollar /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Invoice Generated Today</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Invoice Generated Today`,
                                                    arr: invoiceGeneratedTodayCount.arr,
                                                    count: invoiceGeneratedTodayCount.total
                                                }
                                            })
                                        }}>{invoiceGeneratedTodayCount.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-7 elevation-1"><FaRegMoneyBillAlt /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">University Commission Entered</span>
                                    <span className="info-box-number">
                                        <a href='/finance-university-commission' target='_blank'>{universityCommissionEntered.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-1 elevation-1"><FaFileInvoice /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Course Commission Entered</span>
                                    <span className="info-box-number">
                                        <a href='/finance-course-commission' target='_blank'>{courseCommissionEntered.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaHistory /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Overdue Invoices</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Overdue Invoices`,
                                                    arr: overdueInvoices.arr,
                                                    count: overdueInvoices.total
                                                }
                                            })
                                        }}>{overdueInvoices.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaUserSlash /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Withdraw Students</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Total Withdraw Students`,
                                                    arr: totalWithdrawStudents.arr,
                                                    count: totalWithdrawStudents.total
                                                }
                                            })
                                        }}>{totalWithdrawStudents.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-4 elevation-1"><FaUserClock /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Student Withdraw Request Sent</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Student Withdraw Request Sent`,
                                                    arr: totalWithdrawRequestSent.arr,
                                                    count: totalWithdrawRequestSent.total
                                                }
                                            })
                                        }}>{totalWithdrawRequestSent.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-5 elevation-1"><FaUserCheck /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Student Withdraw Request Approved</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Student Withdraw Request Approved`,
                                                    arr: studentWithdrawRequestApproved.arr,
                                                    count: studentWithdrawRequestApproved.total
                                                }
                                            })
                                        }}>{studentWithdrawRequestApproved.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-6 elevation-1"><FaUserTimes /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Student Withdraw Request Rejected</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Student Withdraw Request Rejected`,
                                                    arr: studentWithdrawRequestRejected.arr,
                                                    count: studentWithdrawRequestRejected.total
                                                }
                                            })
                                        }}>{studentWithdrawRequestRejected.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    </RightsWrapper> */}
                </div>

            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
(FinanceTaxesCount)
